import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'sucursales',
  getAllParams: ({
    name,
    page,
    perPage,
    branch,
    sort,
  }) => ({
    'filter[nombre]': name,
    'filter[sucursal]': branch,
    page,
    per_page: perPage,
    sort,
  }),
});
